const useUrlIframeBankIds = ["1011", "855"];

export { useUrlIframeBankIds };